import React from "react";
import { Box } from "@mui/material";

import { useNavigate } from "react-router-dom";
// import MobileDrawer from "../MobileComponents/MobileDrawer";

// import ProfileBottomTab from "../MobileComponents/ProfileBottomTab";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CreateIcon from "@mui/icons-material/Create";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
// import AttachmentIcon from '@mui/icons-material/Attachment';
import { red } from '@mui/material/colors';
import avtar from "../../assets/images/Profile-Picture.jpg";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../FormikControl";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 10,
    p: 3,
  };
function MobFamilyDetails() {
  const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const initialValues = {
      first_name: "",
      last_name: "",
      relation: "",
      age: "",
      phone: "",
      email: "",
    };
  
    const validationSchema = Yup.object({
      first_name: Yup.string().required("Required"),
      last_name: Yup.string().required("Required"),
      relation: Yup.string().required("Required"),
      age: Yup.string().required("Required"),
      phone: Yup.string().required("Required"),
      email: Yup.string().required("Required"),
    });
  
    const onSubmit = (values) => console.log("Form Data", values);
  return (
    <>
      <div>
        <div className="drawerFixedPatch"></div>
        <div className="drawerWithTop">
          {/* <MobileDrawer /> */}
          <ArrowBackIcon
            className="backArrowMobil"
            onClick={() => navigate("/MobileProfile")}
          />
          <h1>Family Details</h1>
        </div>
      </div>
      <div className="wraperMobile">
        <div className="sectionMobile">
          <div className="famDetailsListMainMob">
            <div className="famDetailsListInrMob">
              <div className="famDetailsListTo">
                <div className="alignfamDetailsListToPro">
                  <img src={avtar} className="useImage"/>
                  <div className="detailsDiMob">
                    <h1>Demo text</h1>
                    <div className="mobWithIco">
                      <LocalPhoneIcon />
                      <p>9881789836</p>
                    </div>
                  </div>
                </div>
                <div className="listDeleEdiMob">
                  <CreateIcon style={{ color: "#21bd21" }} />
                  <DeleteOutlineIcon style={{ color: "#ff5252" }} />
                </div>
              </div>
              <div className="famDetailsListBot">
                <p>
                  <EmailIcon /> <span>namratap.supra@gmail.com</span>
                </p>
                <p>
                  <PeopleAltIcon /> <span>Father (60 Years)</span>
                </p>
              </div>
            </div>

            <div className="famDetailsListInrMob">
              <div className="famDetailsListTo">
                <div className="alignfamDetailsListToPro">
                  <img src={avtar} className="useImage"/>
                  <div className="detailsDiMob">
                    <h1>Demo text</h1>
                    <div className="mobWithIco">
                      <LocalPhoneIcon />
                      <p>9881789836</p>
                    </div>
                  </div>
                </div>
                <div className="listDeleEdiMob">
                  <CreateIcon style={{ color: "#21bd21" }} />
                  <DeleteOutlineIcon style={{ color: "#ff5252" }} />
                </div>
              </div>
              <div className="famDetailsListBot">
                <p>
                  <EmailIcon /> <span>namratap.supra@gmail.com</span>
                </p>
                <p>
                  <PeopleAltIcon /> <span>Father (60 Years)</span>
                </p>
              </div>
            </div>

            <div className="famDetailsListInrMob">
              <div className="famDetailsListTo">
                <div className="alignfamDetailsListToPro">
                  <img src={avtar} className="useImage"/>
                  <div className="detailsDiMob">
                    <h1>Demo text</h1>
                    <div className="mobWithIco">
                      <LocalPhoneIcon />
                      <p>9881789836</p>
                    </div>
                  </div>
                </div>
                <div className="listDeleEdiMob">
                  <CreateIcon style={{ color: "#21bd21" }} />
                  <DeleteOutlineIcon style={{ color: "#ff5252" }} />
                </div>
              </div>
              <div className="famDetailsListBot">
                <p>
                  <EmailIcon /> <span>namratap.supra@gmail.com</span>
                </p>
                <p>
                  <PeopleAltIcon /> <span>Father (60 Years)</span>
                </p>
              </div>
            </div>
          </div>
          <div className='flaotBtnAdd'>
            <Fab onClick={handleOpen} size="medium" sx={{backgroundColor: '#3853ec'}} aria-label="add" >
            <AddIcon sx={{fontSize: 32, color:'white'}}/>
            </Fab>
          </div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
        <Box sx={style}>
          <div className='modalTitleView'>
            <p className='modalTitleTxt'>Add Family Details</p>
            <CloseIcon sx={{ color: red[600], fontSize: 25 }} onClick={handleClose} />
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
          {(formik) => (
          <Form>
          <div className='FormView'>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="First Name"
              placeholder="Enter First Name"
              labelclassName="inputLebal"
              name="first_name"
              className="titleInput"
            />
            </div>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Last Name"
              placeholder="Enter Last Name"
              labelclassName="inputLebal"
              name="last_name"
              className="titleInput"
            />
            </div>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Relation"
              placeholder="Enter Relation"
              labelclassName="inputLebal"
              name="relation"
              className="titleInput"
            />
            </div>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Age"
              placeholder="Enter Age"
              labelclassName="inputLebal"
              name="age"
              className="titleInput"
            />
            </div>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Phone"
              placeholder="Enter Phone"
              labelclassName="inputLebal"
              name="phone"
              className="titleInput"
            />
            </div>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Email"
              placeholder="Enter Email"
              labelclassName="inputLebal"
              name="email"
              className="titleInput"
            />
            </div>
            
            <button className='submitButton' type='submit'>Add to Family</button>
          </div>
          </Form>
          )}
          </Formik>
        </Box>
        </Modal>
        </div>
      </div>

    </>
  );
}

export default MobFamilyDetails;
